import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * Hook para obtener los KPIs de OptProd
 * @returns {Object} - { response, loading, error}
 */

const useFetchKpis = () => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = useCallback(() => {
    setLoading(true)
    setError(null)

    axios
      .get('/optprod/kpis/')
      .then((response) => {
        setResponse(response.data)
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { response, loading, error, refetch: fetchData }
}
export default useFetchKpis
